let cartProviderCode = document.getElementById("cart-provider-code");
let cartSubmitBtn = document.getElementById("cartSubmitBtn");

if (cartProviderCode) {
  let generalSearchMethods = generalSearch(
    cartProviderCode,
    "https://fulfillmentapi.innogrp.com/ExternalRequest/GetProviderCodesForShopify?generalSearch={0}",
    {
      RegExp: /^[^,]+$/,
      ValidationMessage: "Comma(,) is not allowed",
      PassCallback: passCallback,
      FailCallback: failCallback
    }
  );

  var cartForm = document.getElementById("cartform");
  cartForm.addEventListener("submit", prefixProviderTag);

  function prefixProviderTag(e) {
    var hiddenProviderCode = document.getElementById("cart-hidden-provider-code");
    if (hiddenProviderCode.value) {
      hiddenProviderCode.value = "provider_code_" + hiddenProviderCode.value;
    }
    else{
      var providerCode = document.getElementById("cart-provider-code");
      if (providerCode.value) {
        if (generalSearchMethods.validateValue(providerCode.value)) {
          hiddenProviderCode.value = "provider_not_found_" + providerCode.value;  
        }
      }
    }
  }

  function passCallback(){
    cartSubmitBtn.disabled = false;
  }

  function failCallback(){
    cartSubmitBtn.disabled = true;
  }
}